import { css } from '@microsoft/fast-element';
import { cornerRadiusLayer, neutralStrokeStrongRest, strokeThickness } from '@adaptive-web/adaptive-ui/reference';
import { componentBaseStyles } from '@adaptive-web/adaptive-ui';
import { MatchMediaStyleSheetBehavior } from '@microsoft/fast-foundation';
import { darkModeQuery } from '../../style.js';

export default css`
	${componentBaseStyles}

	:host {
		display: block flex;
		width: 100%;
		background: var(--surface-color);
		padding: 24px;
		border-radius: ${cornerRadiusLayer};
	}
	
	form {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		width: 100%;
		gap: 24px;
	}

	label {
		color: ${neutralStrokeStrongRest};
	}

	adaptive-text-area::part(control) {
		box-sizing: border-box;
		height: auto;
	}

	adaptive-text-field::part(label),
	adaptive-text-area::part(label),
	label {
		font-family: var(--body-font-family);
		font-variation-settings: 'wght' 600;
		margin-bottom: var(--padding-xs);
	}

	adaptive-text-field,
	.field,
	.actions {
		grid-column: span 2;
		align-self: flex-end;
	}

	.message-wrapper {
		display: grid;
		grid-column: span 2;

		> adaptive-text-area {
			grid-row: 1;
			width: 100%;
		}

		> .char-count {
			grid-row: 2;
			place-self: flex-end;
		}
	}

	adaptive-text-field:not(.other) {
		grid-column: span 1;
	}

	.field {
		display: flex;
		flex-direction: column;
		grid-column: span 1;
	}

	.placeholder-selected::part(selected-value) {
		color: #6e6f70 !important;
	}

	:is(adaptive-text-field,
	adaptive-number-field,
	adaptive-text-area)::part(control)::placeholder {
		color: #6e6f70 !important;
	}

	@media (max-width: 659px) {
		adaptive-text-field:not(.other), .field {
			grid-column: span 2;
		}
	}
`.withBehaviors(
	new MatchMediaStyleSheetBehavior(
		darkModeQuery,
		css`	
			adaptive-text-field::part(label),
			adaptive-text-area::part(label),
			label {
				color: var(--on-primary-color);
			}

			adaptive-text-field::part(root),
			adaptive-select::part(control),
			adaptive-text-area::part(control) {
				border: ${strokeThickness} solid var(--on-surface-color);
			}
		`
	)
);